var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2760_23345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.06119 25.69L11.6249 7.64249C11.6808 7.4883 11.7746 7.35071 11.8978 7.24247C12.021 7.13423 12.1695 7.05885 12.3295 7.02332C12.4896 6.98779 12.6561 6.99326 12.8135 7.03922C12.9709 7.08518 13.1141 7.17015 13.2299 7.28624L24.7149 18.7712C24.8307 18.8871 24.9154 19.0304 24.9611 19.1877C25.0068 19.345 25.0121 19.5113 24.9764 19.6712C24.9408 19.8311 24.8654 19.9795 24.7572 20.1025C24.649 20.2255 24.5115 20.3192 24.3574 20.375L6.30994 26.9387C6.13565 27.0024 5.9468 27.015 5.76563 26.9749C5.58445 26.9348 5.41849 26.8439 5.28728 26.7127C5.15607 26.5814 5.06509 26.4155 5.02503 26.2343C4.98498 26.0531 4.99752 25.8643 5.06119 25.69Z",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9C21 9 21 6 24 6C27 6 27 3 27 3",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 2V5",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 14L29 16",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 10L30 9",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76123 12.7613L19.2387 22.2388",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6387 24.6387L7.36121 19.3612",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2760_23345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/Party.6b63f0faa9e3c15b310b3753251e3dfe.svg";
export { ForwardRef as ReactComponent };